import { useCallback, useEffect, useMemo, useState } from "react";
import { DashboardService } from "../../../../../services/dashboard";

export const useFetchHistory = (
  granularity: number,
  active: string,
  isRecalculated: boolean,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [data, setData] = useState<any>(null);

  const kpiCode: string = useMemo(() => {
    let kpi: string;

    if (active === "0") {
      kpi = "Payments.Count";
    } else if (active === "1") {
      kpi = "Disbursements.Count";
    } else if (active === "2") {
      kpi = "Contracts.Count";
    } else {
      kpi = "Customers.Count";
    }

    if (granularity === 1) {
      kpi += "Today";
    } else if (granularity === 2) {
      kpi += "ThisMonth";
    } else {
      kpi += "ThisYear";
    }

    return kpi;
  }, [active, granularity]);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await DashboardService.fetchHistory({
        granularity,
        kpiCode,
      });

      setData(res);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [granularity, kpiCode]);

  useEffect(() => {
    fetchData();
  }, [fetchData, isRecalculated]);

  return { isLoading, data };
};
